import { Box, Flex, Stack } from '@chakra-ui/react';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import FreeServiceTag from '@components/features/FreeServiceTag';
import period from '@public/assets/period.svg';
import Image from 'next/image';
import CTA from '../CTA';

const NoImageHero = ({ header, subheader, ctaType, buttonText, showPeriod = false, href = null, onSubmit = null }) => {
  return (
    <Flex px={[0, 0, 16]} py={[8, 8, 16]} gap={12} alignItems="center">
      <Stack w="100%" spacing={6}>
        <Header as="h1">
          {header}
          {showPeriod && (
            <Box display="inline-block" as="span" width={['8px', '12px', '12px', '16px']} ml={[1, 2, 2, 3]}>
              <Image src={period} alt="Stylistic Period" style={{ display: 'inline' }} />
            </Box>
          )}
        </Header>
        <Body1>{subheader}</Body1>
        <CTA
          width={['100%', '100%', '100%', '450px']}
          ctaType={ctaType}
          buttonText={buttonText}
          onSubmit={onSubmit}
          href={href}
        />
        <Box pt={4}>
          <FreeServiceTag />
        </Box>
      </Stack>
    </Flex>
  );
};

export default NoImageHero;
